document.addEventListener("DOMContentLoaded", function () {
    const button = document.querySelector(".tl-custom-position"); // Replace with your button class or ID
    const scrollThreshold = 120; // Scroll distance in pixels

    window.addEventListener("scroll", function () {
        if (window.scrollY > scrollThreshold) {
            button.classList.add("active-scroll");
        } else {
            button.classList.remove("active-scroll");
        }
    });
});
document.addEventListener("DOMContentLoaded", function() {
  // Combine all image container selectors
  const containers = document.querySelectorAll(
    ".product__images__container, .feature-item .feature-image-bg"
  );

  containers.forEach(container => {
    if (container.dataset.zoomAttached) return;
    container.dataset.zoomAttached = "true";

    const ensureTransition = (img) => {
      if (!img) return;
      if (!img.style.transition)
        img.style.transition = "transform 200ms ease";
    };

    const clamp = (v, a = 0, b = 100) => Math.max(a, Math.min(b, v));

    container.addEventListener("mousemove", (e) => {
      // Select image based on container type
      const img =
        container.querySelector(".product-media--image.is-selected img, .is-selected img") ||
        container.querySelector(".product-single__media img") ||
        container.querySelector(".image-wrapper img");

      if (!img) return;

      const rect = img.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return;

      ensureTransition(img);

      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = `${clamp(x)}% ${clamp(y)}%`;
      img.style.transform = "scale(1.6)";
      img.style.willChange = "transform";
    });

    container.addEventListener("mouseleave", () => {
      const img =
        container.querySelector(".product-media--image.is-selected img, .is-selected img") ||
        container.querySelector(".product-single__media img") ||
        container.querySelector(".image-wrapper img");
      if (!img) return;

      img.style.transformOrigin = "center center";
      img.style.transform = "scale(1)";
    });

    const resetSelectedTransforms = () => {
      container.querySelectorAll("img").forEach(i => {
        i.style.transformOrigin = "center center";
        i.style.transform = "scale(1)";
      });
      const cur =
        container.querySelector(".product-media--image.is-selected img, .is-selected img") ||
        container.querySelector(".product-single__media img") ||
        container.querySelector(".image-wrapper img");
      if (cur) ensureTransition(cur);
    };

    resetSelectedTransforms();

    // Handle Flickity sliders if present
    const slider = container.querySelector('.flickity-slider');
    if (slider) {
      const mo = new MutationObserver(muts => {
        for (const m of muts) {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            resetSelectedTransforms();
            break;
          }
        }
      });
      mo.observe(slider, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
  });
});
